import { useEffect, useState } from 'react';

/**
 * True once the window has finished loading (document.readyState 'complete',
 * or the `load` event). Used to hold back heavy, decorative downloads such as
 * the hero film so they never compete with the still, which is the LCP image,
 * for bandwidth. SSR-safe: with no document it reports true.
 */
export default function usePageLoaded(): boolean {
  const [loaded, setLoaded] = useState<boolean>(
    () => typeof document === 'undefined' || document.readyState === 'complete',
  );

  useEffect(() => {
    if (loaded || typeof window === 'undefined') return undefined;
    // `load` may have fired between the first render and this effect.
    if (document.readyState === 'complete') {
      setLoaded(true);
      return undefined;
    }
    const onLoad = () => setLoaded(true);
    window.addEventListener('load', onLoad);
    return () => window.removeEventListener('load', onLoad);
  }, [loaded]);

  return loaded;
}
